// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { ProductListActionsStyles } from "@rugby/Overrides/Widgets/ProductList/ProductListActions";
import PlusRound from "@rugby/XDL/Icons/PlusRound";
import { xFlexGap } from "@rugby/XDL/Utilities/SharedStyles";
import { css } from "styled-components";

const customProductListActionsStyle: ProductListActionsStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            width: 100%;
            height: 75%;
        `,
    },
    priceAndAvailabilityWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            > * {
                margin-bottom: 5px;
                &:last-child {
                    margin-bottom: 0;
                }
            }

            .hasSamePrices {
                span {
                    font-weight: bold;
                }
                span[data-test-selector="productPrice_unitNetPrice"] {
                    font-size: 18px;
                }
            }
        `,
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin-top: 10px;
        `,
    },
    addToCartButton: {
        css: css`
            width: 80%;
            padding: 0 22px;
            min-height: 40px;
            flex: 1;
        `,
    },
    quantityOrderedWrapper: {
        css: css`
            flex: 1;
            display: flex;    
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                display: flex;
                max-width: 65px;
                flex-basis: 65px;
                word-break: keep-all;
                padding-right: 5px;
            `,
        },
    },
    addToListWrapper: {
        css: css`
            margin-top: 20px;
            min-height: 2rem;
        `,
    },
    price: {
        wrapper: {
            css: css`
                display: inline-flex;
                width: 100%;
                max-width: 100%;
            `,
        },
        price: {
            unitOfMeasureText: {
                css: css`
                    font-size: 13px;
                    font-weight: bold;
                    letter-spacing: 0;
                    line-height: 21px;
                `,
            },
            priceText: {
                css: css`
                    font-size: 18px;
                    font-weight: bold;
                    letter-spacing: 0;
                    line-height: 21px;
                `,
            },
        },
    },
    addToListLink: {
        link: {
            color: "secondary",
            icon: {
                iconProps: {
                    src: PlusRound,
                    color: "secondary",
                    size: 12,
                },
            },
            css: css`
                flex: 1;
                justify-content: flex-end;
                align-items: center;
            `,
            typographyProps: {
                size: 14,
                css: css`
                    letter-spacing: 0;
                    line-height: 22px;
                `,
            },
        },
    },
    availabilityWrapper: {
        messageGridItem: {
            css: undefined,
        },
        availabilityByWarehouseLinkGridItem: {
            css: undefined,
        },
    },
};

export const productGridActionsStyles: ProductListActionsStyles = {
    wrapper: {
        css: css`
            ${customProductListActionsStyle.wrapper?.css}
            width: auto;
        `,
    },
};

export default customProductListActionsStyle;
